module.exports = __webpack_public_path__ + "img/flower_leaf_13.48943735.png";